import type { Participant } from './callRoom';
import { ParticipantTile } from './Tile';

/*
 * Полоса маленьких плиток: сбоку на вебе, снизу на телефоне. Нужна там, где
 * сцену занял кто-то один — показ экрана или раскладка «докладчик», — и всё
 * равно надо видеть, кто в звонке и кто говорит.
 */

export function Strip({
  people,
  side,
  onPick,
}: {
  people: Participant[];
  side: 'right' | 'bottom';
  /** Нажатие по плитке: администратор открывает ею меню участника. */
  onPick?: (p: Participant, anchor: HTMLElement) => void;
}) {
  if (!people.length) return null;
  return (
    <div className={`call-strip ${side}`}>
      {people.map((p) => (
        <ParticipantTile
          key={p.id}
          p={p}
          size="sm"
          onPick={onPick && !p.isMe ? (anchor) => onPick(p, anchor) : undefined}
        />
      ))}
    </div>
  );
}
